<template>
    <div>
      <v-container>
        <generalAlert
          v-if="alert"
          :alert="alert"
          :alertType="alertType"
          :message="successResponse"
        />
        <v-row >
          <v-col v-if="superAdminUser" cols="1" sm="1" md="1">
            <v-btn
              @click="backToAgenciesSuspendedSubscriptions()"
              color="primary"
              icon
            >
              <v-icon>mdi-arrow-left-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col v-if="agencyAdminUser" cols="1" sm="1" md="1">
            <v-btn
              @click="backToAgencySuspendedSubscriptions()"
              color="primary"
              icon
            >
              <v-icon>mdi-arrow-left-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col v-if="subscriberUser" cols="1" sm="1" md="1">
            <v-btn @click="backToUsersSubscriptions()" color="primary" icon>
              <v-icon>mdi-arrow-left-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="9">
            <h2>View Paused Subscription</h2>
          </v-col>
          <v-col cols="2">
            <activateSubscription
              :subscription="this.selectedSubscription"
              @successAlert="reactivateSubscription"
            />
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-card class="px-4 py-4 mb-4">
              <v-row justify="center" align="center">
                <v-col cols="2" sm="2" md="1" lg="1">
                  <v-avatar>
                    <img lazy-src="../assets/defaultimage.jpeg" :src="subscriptionIcon" />
                  </v-avatar>
                </v-col>
                <v-col cols="10" sm="10" md="11" lg="11">
                  Primary Page: {{ this.subscriptionPrimaryPage }}
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <h4>Accont Holder</h4>
                  <p class="mb-0">Name: {{ this.selectedSubscription.name }}</p>
                  <p class="mb-0">Email: {{ this.selectedSubscription.email }}</p>
                  <p class="mb-0">
                    Mobile: {{ this.selectedSubscription.mobile }}
                  </p>
                </v-col>
                <v-col ccols="12" sm="12" md="6" lg="6">
                  <h4>Package Info</h4>
                  <p class="mb-0">Package: {{ this.subscriptionPackage }}</p>
                  <!-- <p class="mb-0">Pages: {{ this.selectedSubscription.pageNames.map(page => page.name).join(', ') }}</p> -->
                  <p class="mb-0">
                    Date Created:
                    {{ this.selectedSubscription.dateCreated | formatDate }}
                  </p>
                </v-col>
                <v-col cols="12">
                  <h4>Reason for pausing</h4>
                  <p class="mb-0">
                    Reason: {{ this.selectedSubscription.pauseReason }}
                  </p>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-tabs
                class="tabsbackground"
                fixed-tabs
                v-model="tab"
                height="80px"
              >
                <v-tab
                  style="font-size: 12px"
                  v-for="item in items"
                  :key="item.tab"
                >
                  <h3>{{ item.tab }}</h3>
                </v-tab>
              </v-tabs>
  
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <div>
                    <v-row style="padding: 20px" justify="center">
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="reportSets"
                          :items-per-page="5"
                          :loading="overlay"
                          loading-text="Loading... Please wait"
                        >
                          <template v-slot:[`item.date`]="{ item }">
                            {{ item.date }}
                          </template>
                          <template
                            v-slot:[`item.competitiveReportId`]="{ item }"
                          >
                            <v-btn
                              v-if="item.competitiveReportId"
                              icon
                              @click="
                                viewReport(item.competitiveReportId.reportId)
                              "
                              color="primary"
                              ><v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <p v-else class="mb-0">N/A</p>
                          </template>
                          <template v-slot:[`item.insightsReportId`]="{ item }">
                            <v-btn
                              v-if="item.insightsReportId"
                              @click="
                                viewInsightsReport(item.insightsReportId.reportId)
                              "
                              icon
                              color="primary"
                              ><v-icon>mdi-eye</v-icon></v-btn
                            >
                            <p v-else class="mb-0 checkaccessbutton">N/A</p>
                          </template>
                          <template v-slot:[`item.instagramReportId`]="{ item }">
                            <v-btn
                              v-if="item.instagramReportId"
                              @click="
                                viewInstagramInsightsReport(
                                  item.instagramReportId.reportId
                                )
                              "
                              icon
                              color="primary"
                              ><v-icon>mdi-eye</v-icon></v-btn
                            >
                            <p v-else class="mb-0">N/A</p>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
                <v-tab-item>
                <div class="text-center">
                  <v-row style="padding: 20px" justify="center">
                    <v-col cols="12" class="text-center">
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <h2>Billing Address</h2>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='Street Address'
                            v-model="paypalSubscriberAddress.address_line_1"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='Area'
                            v-model="paypalSubscriberAddress.address_line_2"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='City/Town'
                            v-model="paypalSubscriberAddress.admin_area_1"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='City/Town'
                            v-model="paypalSubscriberAddress.admin_area_2"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-btn
                            rounded
                            color="primary"
                            small
                          >
                            Update
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" class="py-0 text-left">
                          <h4 v-if="paypalSubscriptionDataStatus == 'ACTIVE'">Status: <v-chip small color="success">{{ paypalSubscriptionDataStatus }}</v-chip></h4>
                          <h4 v-else>Status: <v-chip small color="error">{{ paypalSubscriptionDataStatus }}</v-chip></h4>
                          <h3 v-if="paypalBillingInfo.next_billing_time">Next Billing Date: {{ paypalBillingInfo.next_billing_time | formatDate }}</h3>
                          <h3 v-if="paypalBillingInfo.last_payment">Last Payment Date: {{ paypalBillingInfo.last_payment.time | formatDate }}</h3>
                          <p>Failed Payments: {{ paypalBillingInfo.failed_payments_count }}</p>
                          <v-alert
                              v-if="paypalBillingInfo.failed_payments_count == 1"
                              dense
                              outlined
                              type="error"
                            >
                            <strong>Out Standing Amount:{{ paypalBillingInfo.last_payment.amount.currency_code }} {{ paypalBillingInfo.last_payment.amount.value | formatNumber }}!</strong>
                            </v-alert>
                          <!-- <p v-if="paypalBillingInfo.failed_payments_count == 1">Out Standing Amount: {{ paypalBillingInfo.last_payment.amount.value }}</p> -->
                        </v-col>
                        <v-col cols="12" class="py-0"v-for="item in paypalBillingInfo.cycle_executions"
                              :key="item.id">
                              <!-- v-if="item.tenure_type == 'TRIAL' && item.cycles_remaining == 1 || item.tenure_type == 'REGULAR'" -->
                            <v-card
                              
                              class="my-2"
                              >
                              <v-card-text class="py-3 px-0">
                                <v-row>
                                  <v-col cols="4" :class="billingCycleClass(item.tenure_type)">
                                    <h3 class="white--text pt-1">{{item.tenure_type}}</h3>
                                  </v-col>
                                  <v-col cols="8">
                                    <h3 v-if="item.tenure_type == 'TRIAL'">{{ daysLeft }} Days Left</h3>
                                    <h3 v-if="item.tenure_type == 'REGULAR' && paypalBillingInfo.next_billing_time">Next - {{paypalBillingInfo.next_billing_time | formatDate}}</h3>
                                    <h3 v-if="item.tenure_type == 'REGULAR' && paypalBillingInfo.last_payment">Last - {{paypalBillingInfo.last_payment.time | formatDate}}</h3>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120"
          >Please Wait...</v-progress-circular
        >
      </v-overlay>
    </div>
  </template>
  
  <script>
  import { getAuth } from "firebase/auth";
  import generalAlert from "../components/alerts/generalAlert.vue";
  import activateSubscription from "../components/dialogs/activeSubscription.vue"
  import { firebaseApp } from "../firebaseConfig";
  import { getFirestore, doc, getDoc } from "firebase/firestore";
  import { getFunctions, httpsCallable } from "firebase/functions";
  const db = getFirestore(firebaseApp);
  import moment from "moment-timezone";
  
  export default {
    components: {
      generalAlert,
      activateSubscription,
    },
    props: ["id", "uid"],
    data: () => ({
      selectedSubscription: [],
      subscriptionIcon: "",
      subscriptionPrimaryPage: "",
      subscriptionPackage: [],
      subscriptionPages: [],
      paypalSubscription:'',
      reports: [],
      insightsReports: [],
      overlay: false,
      tab: null,
      items: [
        { tab: "Client Reports", content: "Tab 1 Content" },
        { tab: "Billing Details", content: "Tab 2 Content" },
      ],
      headers: [
        {
          text: "Date",
          sortable: false,
          value: "date",
          align: "center",
        },
        {
          text: "Competitive Report",
          sortable: false,
          value: "competitiveReportId",
          align: "center",
        },
        {
          text: "Facebook Insights",
          sortable: false,
          value: "insightsReportId",
          align: "center",
        },
        {
          text: "Instagram Insights",
          sortable: false,
          value: "instagramReportId",
          align: "center",
        },
      ],
      pages: [],
      superAdminUser: false,
      agencyAdminUser: false,
      subscriberUser: false,
      successResponse: "",
      alertType: "",
      alert: false,
      search: "",
      invoices: [],
      subscriberUserData: [],
      stripeSubscription: [],
      stripeSubscriptionDefaultCardId: "",
      reportSets: [],
      packageType:'',
      subscriptionDateCreated:'',

      paypalSubscription: "",
      paypalSubscriptionData: [],
      paypalBillingInfo:[],
      paypalSubscriberInfo:[],
      paypalSubscriberAddress:[],
      paypalSubscriptionDataStatus:"",
    }),
    created() {
      this.getCurrentUser();
    },
    filters: {
      formatDate: function (value) {
        return moment(value).format("dddd, MMMM Do YYYY");
      },
      formatNextDate: function (value) {
        return moment(value).add(30, "days").format("MMMM Do YYYY");
      },
      formatCurrency: function (value) {
        const number = Number(value) || 0;
        return (number / 100).toFixed(2);
      },
      formatInvoiceDate: function (value) {
        const invoiceDate = new Date(value * 1000); // Convert seconds to milliseconds
        const formattedDate = `${invoiceDate.getDate()} ${invoiceDate.toLocaleString(
          "default",
          { month: "short" }
        )} ${invoiceDate.getFullYear()}, ${invoiceDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
        return formattedDate;
      },
      //format the paypal price 
      formatNumber(value) {
        if (value !== undefined && value !== null) {
          return parseFloat(value).toFixed(2);
        }
        return '';
      },
      daysFromNow(timestamp) {
        if(timestamp){
          const subscriptionDate = moment(timestamp);
          const targetDate = subscriptionDate.add(7, 'days');
          const today = moment();
          return targetDate.diff(today, 'days');
        }else{
          return ''
        }
      }
    },
    methods: {
        billingCycleClass(tenureType) {
          return tenureType === 'TRIAL' ? 'trial-cycle' : 'regular-cycle';
        },
        isExpired(date) {
          if (this.packageType === "Compeat Demo Subscription" && this.$store.state.user.userType != 'SMM') {
          const dateNew = moment(date);
          const targetDate = dateNew.clone().add(7, "days");
          const today = moment();
          const daysLeft = targetDate.diff(today, "days");

          // Disable the button if daysLeft is less than or equal to 0
          return daysLeft <= 0;
        }
      },
      getCurrentUser() {
        const auth = getAuth(firebaseApp);
        const user = auth.currentUser;
        user
          .getIdTokenResult()
          .then(async (idTokenResult) => {
            let userClaims = idTokenResult.claims.UserRole;
  
            if (userClaims == "Super Admin") {
              this.superAdminUser = true;
            } else if (
              userClaims == "Agency Admin" ||
              userClaims == "Social Marketing Manager"
            ) {
              this.agencyAdminUser = true;
            } else if (userClaims == "Subscriber") {
              this.subscriberUser = true;
            }
            this.getSubscriptionInfo();
          })
          .catch((error) => {
            console.log(error);
            this.overlay = false;
          });
      },
      async getSubscriptionInfo() {
        this.overlay = true;
        this.insightsReports = [];
        this.reports = [];
        try {
          console.log("this.uid", this.uid);
          const docRef = doc(db, "pausedsubscriptions", this.uid); // Use doc() to create a reference to the document
          const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot
  
          if (!docSnapshot.exists()) {
            throw new Error("Document not found");
          }
          this.selectedSubscription = docSnapshot.data();
          this.packageType = this.selectedSubscription.package.packageType;
          this.subscriptionDateCreated = this.selectedSubscription.dateCreated;
          this.subscriptionPages = this.selectedSubscription.package.pages;
          this.subscriptionIcon = this.selectedSubscription.package.pages[0].icon;
          this.subscriptionPrimaryPage = this.selectedSubscription.package.primaryPage.name;
          this.subscriptionPackage = this.selectedSubscription.package.currentPackage;
          this.paypalSubscription = this.selectedSubscription.paypalSubscriptionId
  
          const competitiveReportIds =
            this.selectedSubscription.reportIds.competitiveReportIds || [];
          const insightsReportIds =
            this.selectedSubscription.reportIds.insightsReportIds || [];
          const instagramReportIds =
            this.selectedSubscription.reportIds.instagramReportIds || [];
  
          const maxLength = Math.max(
            competitiveReportIds.length,
            insightsReportIds.length,
            instagramReportIds.length
          );
          // Combine the arrays at each index, including the report dates
          const combinedArray = Array.from({ length: maxLength }, (_, index) => {
            const competitiveReportId = competitiveReportIds[index] || null;
            const insightsReportId = insightsReportIds[index] || null;
            const instagramReportId = instagramReportIds[index] || null;
  
            // Check if competitiveReportId has a date; if not, check insightsReportId
            const date =
              competitiveReportId && competitiveReportId.date
                ? competitiveReportId.date
                : insightsReportId && insightsReportId.date
                ? insightsReportId.date
                : null;
  
            return {
              competitiveReportId,
              insightsReportId,
              instagramReportId,
              date,
            };
          });
  
          this.reportSets = combinedArray;
          this.getSubscriber()
  
        } catch (err) {
          this.overlay = false;
          console.log("err", err);
        }
      },
          // Gets the subscription user
        async getSubscriber() {
          const docRef = doc(db, "users", this.selectedSubscription.subscriberId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            this.subscriberUserData = docSnap.data();
            console.log(
              "this.selectedSubscription.paymentStatus",
              this.selectedSubscription.paypalSubscriptionId
            );
            if (this.selectedSubscription.paypalSubscriptionId) {
              this.getPaypalSubcription();
            } else {
              this.overlay = false;
            }
          } else {
            console.log("No such document!");
            this.overlay = false;
          }
        },
        getPaypalSubcription() {
          console.log('this.paypalSubscription', this.paypalSubscription)
          // paypalSubscription
          const functions = getFunctions(firebaseApp, "europe-west2");
          const getPaypalSubscriptionData = httpsCallable(
            functions,
            "getPaypalSubscriptionData"
          );

          getPaypalSubscriptionData({
            paypalSubscription: this.paypalSubscription,
          }).then((result) => {
            this.paypalSubscriptionData = result.data.response;
            this.paypalSubscriptionDataStatus = this.paypalSubscriptionData.subscriptionData.status
            this.paypalBillingInfo = this.paypalSubscriptionData.subscriptionData.billing_info
            this.paypalSubscriberInfo = this.paypalSubscriptionData.subscriptionData.subscriber
            this.paypalSubscriberAddress = this.paypalSubscriptionData.subscriptionData.subscriber.shipping_address.address

            if(this.paypalSubscriptionData.transactionData){
              this.transactionData = this.paypalSubscriptionData.transactionData;
            }
            console.log("this.paypalSubscriptionData", this.paypalBillingInfo);

            // this.transactionData = this.paypalSubscriptionData.transactionData;

            this.overlay = false;

          });
        },
      async reactivateSubscription(message, typeOfAlert){
        this.successResponse = message;
        this.alertType = typeOfAlert;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.$router.push({
            name: "singleSubscription",
            params: {
              id: this.id,
              uid: this.uid,
            },
          });
        }, 3000);
      },
      successAlert(message, typeOfAlert) {
        this.successResponse = message;
        this.alertType = typeOfAlert;
        this.alert = true;
        this.getSubscriptionInfo();
        setTimeout(() => {
          this.alert = false;
        }, 5000);
      },
      backToUsersSubscriptions() {
        this.$router.push("/");
      },
      backToAgencySuspendedSubscriptions() {
        this.$router.push("/agency-suspended-subscriptions");
      },
      backToAgenciesSuspendedSubscriptions() {
        this.$router.push({
          name: "singleAgency",
          params: {
            id: this.id,
          },
        });
      },
      viewReport(item) {
        this.$router.push({
          name: "singleReport",
          params: {
            id: this.id,
            uid: this.uid,
            reportId: item,
          },
        });
      },
      viewInsightsReport(item) {
        this.$router.push({
          name: "insightsReport",
          params: {
            id: this.id,
            uid: this.uid,
            reportId: item,
          },
        });
      },
      viewInstagramInsightsReport(item) {
        this.$router.push({
          name: "instagramInsightsReport",
          params: {
            id: this.id,
            uid: this.uid,
            reportId: item,
          },
        });
      },
      openUrl(url) {
        window.open(url, "_blank");
      },
    },
  };
  </script>
  